import React from 'react';
import Title from '../Components/Elements/Title';
import MainContainer from '../Components/Elements/MainContainer';
import { Helmet } from 'react-helmet';
import Text from '../Components/Elements/Text';
import { Link } from 'react-router-dom';
import faqJson from '../Data/faqs.json';

interface Props {
    useHelm?: boolean;
}

const FAQs = ({ useHelm = false } : Props) => {
    return (
        <MainContainer>
            {
                useHelm && (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>H&R Wedding | FAQs</title>
                    </Helmet>
                )
            }
            <Title size="3">FAQs</Title>
            {
                faqJson.map((faq : FaqProps) => (
                    <FAQ key={faq.key} question={faq.question} answer={faq.answer} />
                ))
            }


            { useHelm && <Text className="pt-4">
                <Link
                    to="/app"
                    className="bg-blue-500 hover:bg-blue-700 font font-lora text-white font-bold py-2 px-4 rounded my-2 inline-block text-center"
                >
                    Back to home
                </Link>
            </Text>}
        </MainContainer>
    )
}

interface FaqProps {
    key: string
    question: string
    answer: string
}

const FAQ = ({question, answer} : FaqProps) => {
    return (
        <div className='my-3 py-3'>
            <Text><span className="font-bold">Q:</span> {question}</Text>
            <Text><span className="font-bold">A:</span> {answer}</Text>
            <hr className='mt-3 w-[50%] mx-auto' />
        </div>
    )
}

export default FAQs;